import { Component } from '@angular/core';
import { ErrorBlock } from '../../models/error-block.model';

@Component({
  selector: 'iw-statistics',
  templateUrl: './iw-statistics.component.html',
  styleUrls: ['./iw-statistics.component.scss']
})
export class IwStatisticsComponent {

  public textToDecode = "";
  public decodedText = "";

  public get isRedirectDisabled() {
    return !this.canActivateRedirect();
  }

  public decodeString() {
    this.decodedText = JSON.stringify(JSON.parse(atob(this.textToDecode)), undefined, 4);
  }

  public encodeString() {
    this.textToDecode = btoa(JSON.stringify(JSON.parse(this.decodedText)));
  }

  public redirectKibana() {
    const uuid = this.getUuid();
    const tenant = this.getTenant();
    const timeframe = 'now-60d,to:now';
    const kibanaUrl = `/kibana/app/dashboards#/view/59c2dd10-7066-11eb-845a-333767f0f03f?_g=`+
    `(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:${timeframe}))&_a=` +
    `(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,controlledBy:` +
    `'1613486842893',disabled:!f,index:'732b5060-705d-11eb-845a-333767f0f03f',` +
    `key:tenant.keyword,negate:!f,params:(query:${tenant}),type:phrase),query:(` +
    `match_phrase:(tenant.keyword:${tenant}))),('$state':(store:appState),meta:(alias:!n,disabled:!f,` +
    `index:'732b5060-705d-11eb-845a-333767f0f03f',key:UUID,negate:!f,params:(` +
    `query:'${uuid}'),type:phrase),query:(match_phrase:(` +
    `UUID:'${uuid}')))),fullScreenMode:!f,options:(hidePanelTitles:!f,` +
    `useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:Monitoring,viewMode:view)`;
    window.open(kibanaUrl, '_blank');
  }

  private canActivateRedirect() {
    if (this.decodedText.length) {
      const decodedBlock: any = JSON.parse(this.decodedText);
      return !!decodedBlock.errorPayload.mdcContext;
    }
    return false;
  }

  private getUuid(): string {
    if (this.decodedText.length) {
      const decodedBlock: any = JSON.parse(this.decodedText);
      return decodedBlock.errorPayload.mdcContext.UUID;
    }
    return '';
  }

  private getTenant(): string {
    if (this.decodedText.length) {
      const decodedBlock: any = JSON.parse(this.decodedText);
      return decodedBlock.errorPayload.mdcContext.tenant;
    }
    return '';
  }
}
